const features = [
  {
    icon: 'ri-4k-line',
    title: '4K超清画质',
    description: '支持4K超高清分辨率，每一帧画面都纤毫毕现，带来影院级视觉享受。',
    color: 'accent',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多终端同步',
    description: '手机、平板、电脑、电视无缝切换，观看进度自动同步，追剧不间断。',
    color: 'primary',
  },
  {
    icon: 'ri-speed-mini-line',
    title: '流畅不卡顿',
    description: '全球CDN加速节点覆盖，智能码率自适应技术，确保流畅稳定的观影体验。',
    color: 'accent',
  },
  {
    icon: 'ri-shield-check-line',
    title: '无广告纯净体验',
    description: '纯净观影环境，无弹窗、无贴片广告，让你沉浸在精彩内容中不受打扰。',
    color: 'primary',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '无需下载',
    description: '打开即看，无需安装任何软件或插件。浏览器直接播放，方便快捷。',
    color: 'accent',
  },
  {
    icon: 'ri-global-line',
    title: '海量内容库',
    description: '电影、电视剧、综艺、纪录片、动漫、少儿等全品类覆盖，总有你想看的。',
    color: 'primary',
  },
];

export default function FeatureHighlights() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            为什么选择在线观看？
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">
            我们致力于打造最优质的在线观看体验，让每个人都能轻松享受高清内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="p-6 rounded-lg bg-background-100 border border-background-200/60 hover:border-background-300/60 transition-all duration-300 group cursor-default"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-lg mb-4 ${
                feature.color === 'primary'
                  ? 'bg-primary-500/15 text-primary-500'
                  : 'bg-accent-500/15 text-accent-500'
              }`}>
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}